// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__3w6Se","log":"ModalInventoryLogs_log__2Vcr8","date":"ModalInventoryLogs_date__2b6r5","userName":"ModalInventoryLogs_userName__17_5k"};